/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  quarter: '',
  manufacturerList: [],
  checkDetails: [],
  errorMessagesInRedux: {},
  searchInvoiceAuditObj: {},
  invoiceAuditDetailObj: {},
  searchScreenObj: {},
  perviousInvoiceCriteriaRedux: [],
  searchInvoiceByCriteriaList: [],
  ndcLevelDetailList: [],
  ndcAuditDescriptionList: [],
  saveOrUpdateMessage: '',
  changesDataList: [],
  selectedAuditType: '',
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_PLAN_TYPE_DATA:
      // eslint-disable-next-line vars-on-top, no-var
      var updatedArray = [];
      if (action.checkbox) {
        // eslint-disable-next-line vars-on-top, no-var
        var localAr = action.checkbox;
        if (localAr?.PLAN_TYPE_CD?.length > 0) {
          const planArray = localAr?.PLAN_TYPE_CD;
          planArray.forEach((element) => {
            if (element?.codeValueID?.codeValue === 'FD') {
              const indexOf = _.findIndex(planArray, element);
              if (!_.isNull(indexOf) && indexOf >= 0) {
                updatedArray = arrayMove(localAr?.PLAN_TYPE_CD, indexOf, 0);
              }
              localAr.PLAN_TYPE_CD = updatedArray;
            }
          });
        }
      }
      return {
        ...state,
        // eslint-disable-next-line block-scoped-var
        checkbox: localAr,
      };
    case actionTypes.GET_COMMON_DROPDOWN_DATA:
      return {
        ...state,
        dropdown: action.dropdown,
      };
    case actionTypes.GET_QUARTER_DATA:
      return {
        ...state,
        quarter: action.quarter,
      };
    case actionTypes.SEARCH_INVOICE_AUDIT_TAB_DATA:
      return {
        ...state,
        searchInvoiceAuditObj: action.searchInvoiceAuditObj,
      };
    case actionTypes.INVOICE_AUDIT_DETAIL_TAB_DATA:
      return {
        ...state,
        invoiceAuditDetailObj: action.invoiceAuditDetailObj,
      };
    case actionTypes.SEARCH_SCREEN_TAB_DATA:
      return {
        ...state,
        searchScreenObj: action.searchScreenObj,
      };
    case actionTypes.PERV_SEARCH_INVOICE_CRITERIA_DATA:
      return {
        ...state,
        perviousInvoiceCriteriaRedux: action.perviousInvoiceCriteriaRedux,
      };
    case actionTypes.GET_MANUFACTURER_DATA:
      return {
        ...state,
        manufacturerList: action.manufacturerList,
      };

    case actionTypes.SELECTED_REBATE_PROGRAM:
      return {
        ...state,
        selectedRebateProgram: action.selectedRebateProgram,
      };
    case actionTypes.QTR_VALUE:
      return {
        ...state,
        quarterInput: action.quarterInput,
      };

    case actionTypes.GET_SEARCH_INVOICE_BY_CRITERIA:
      // eslint-disable-next-line vars-on-top, no-var
      var dataSearch = { ...action.searchInvoiceByCriteriaList };

      // eslint-disable-next-line vars-on-top, no-var
      var dataArray = [];
      if (
        dataSearch?.invoiceAuditGridResponse &&
        dataSearch?.invoiceAuditGridResponse.length > 0
      ) {
        dataArray = dataSearch?.invoiceAuditGridResponse;
        dataArray = dataArray.filter((item) => item?.auditTypeCd !== 'IRGL');
      }
      if (dataArray?.length > 0) {
        dataSearch.invoiceAuditGridResponse = dataArray;
      }

      return {
        ...state,
        searchInvoiceByCriteriaList: dataSearch,
      };
    case actionTypes.GET_NDC_LEVEL_DETAIL_LIST:
      return {
        ...state,
        ndcLevelDetailList: action.ndcLevelDetailList,
      };
    case actionTypes.GET_NDC_AUDIT_DESCRIPTION:
      return {
        ...state,
        ndcAuditDescriptionList: action.ndcAuditDescriptionList,
      };
    case actionTypes.SAVE_OR_UPDATE:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };

    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_IA:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };

    case actionTypes.PAGINATE_VALUE_FOR_DISPLAY:
      return { ...state, pagValueForDisplay: action.pagValueForDisplay };
    case actionTypes.ALL_CHANGES_INVOICE_AUDITS_DATA_LIST:
      return { ...state, changesDataList: action.changesDataList };
    case actionTypes.SELECTED_INVOICE_AUDIT_TYPE:
      return { ...state, selectedAuditType: action.payload };
    default:
      return state;
  }
};

export default reducer;
